import React, { useEffect } from 'react';
import irinavideo from '../assets/fondoboton3.mp4';
import styles from './S5.module.css';

import { Link, useNavigate } from 'react-router-dom';

const ContactSection = () => {
  useEffect(() => {
    const fadeInElements = document.querySelectorAll(`.${CSS.escape(styles.fadeIn)}`);
    fadeInElements.forEach(element => {
      element.style.opacity = 1;
      element.style.transform = 'translateY(0)';
    });
  }, []);

  const navigate = useNavigate();

  return (
    <section id="contact" className={styles.contact}>
      {/*<video src={irinavideo} autoPlay loop muted playsInline className={styles.backgroundVideo}></video>*/}
      <div className={styles.container}>
      <div className={styles.texto}><span className={styles.highlight1}>Agenda una</span> <span className={styles.highlight2}> Demo</span></div>
        
        <button className={`${styles.neonButton} ${styles.fadeIn}`} onClick={() => navigate('/contacto')}>
          <span className={styles.diseño}></span>
          <span className={styles.diseño}></span> 
          <span className={styles.diseño}></span>
          <span className={styles.diseño}></span>
          <span className={styles.letter}>A</span>
          <span className={styles.letter}>G</span>
          <span className={styles.letter}>E</span>
          <span className={styles.letter}>N</span>
          <span className={styles.letter}>D</span>
          <span className={styles.letter}>A</span>
          <span className={styles.letter}>R</span>
        </button>
      </div>
    </section>
  );
};

export default ContactSection;
